export const version = "1.7.18";
export const channel = "core";
export const gitcommit = "unknown";
